package com.wintermar.inspection

import kotlin.Boolean
import kotlin.ByteArray
import kotlin.Double
import kotlin.Long
import kotlin.String

public data class GetFailedSubmissions(
  public val answerType: String,
  public val answerId: String,
  public val inspectionId: String,
  public val questionId: String,
  public val notes: String?,
  public val isRequiredFileOrNotes: Boolean?,
  public val answerDateIso: String?,
  public val answerOptionId: String?,
  public val answerText: String?,
  public val lastUpdated: String?,
  public val isSubmitted: Boolean?,
  public val findingCategory: String?,
  public val fileId: String?,
  public val fileName: String?,
  public val fileOriginalName: String?,
  public val fileBlob: ByteArray?,
  public val filePath: String?,
  public val fileSize: Long?,
  public val fileType: String?,
  public val fileStatus: String?,
  public val fileHasGenerateChunk: Boolean?,
  public val locationId: String?,
  public val latitude: Double?,
  public val longitude: Double?,
  public val locationName: String?,
  public val selectionId: String?,
  public val answerSelectionId: String?,
  public val answerSelectionValue: String?,
)
